import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static targets = ['selectAll', 'select', 'control']

  selectAll = () => {
    if (this.selectAllTarget.checked) {
      this.checkAll(true)
    }
    else {
      this.checkAll(false)
    }
    this.updateSelectAllChecked()
    this.updateControls()
    this.broadcast()
  }

  select = () => {
    this.updateSelectAllChecked()
    this.updateControls()
    this.broadcast()
  }

  isAllChecked() {
    return this.selectTargets.every(value => value.checked)
  }

  isAnyChecked() {
    return this.selectTargets.some(value => value.checked)
  }

  checkAll(checked) {
    this.selectTargets.forEach((element) => {
      element.checked = checked
    })
  }

  updateSelectAllChecked() {
    if (this.isAllChecked()) {
      this.selectAllTarget.checked = true
      delete this.selectAllTarget.dataset.mixed
    }
    else if (this.isAnyChecked()) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.dataset.mixed = true
    }
    else {
      this.selectAllTarget.checked = false
      delete this.selectAllTarget.dataset.mixed
    }
  }

  updateControls() {
    if (this.isAnyChecked()) {
      this.controlTargets.forEach((element) => {
        element.classList.remove('hidden')
      })
    }
    else {
      this.controlTargets.forEach((element) => {
        element.classList.add('hidden')
      })
    }
  }

  broadcast = () => {
    const selected = this.isAnyChecked()
    emit('listSelect', {
      bubbles: true,
      detail: { selected: selected },
    })
  }
}
